import React from 'react'

const SendToFinanceModalUI = ({
  loan,
  onConfirmClick,
  onCancelClick,
  submitting,
  successMsg,
  errorList
}) => {
  return (
    <div className="modal-backdrop" style={backdropStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>Send to Finance</h3>

        {successMsg && (
          <div style={{
            color: 'green',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#d4edda',
            borderRadius: '4px',
            border: '1px solid #c3e6cb'
          }}>
            {successMsg}
          </div>
        )}

        {errorList && errorList.length > 0 && (
          <div style={{
            color: '#721c24',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#f8d7da',
            borderRadius: '4px',
            border: '1px solid #f5c6cb'
          }}>
            <strong>Error(s):</strong>
            <ul style={{ marginTop: '5px', marginBottom: '0', paddingLeft: '20px' }}>
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        {loan && (
          <div style={{
            fontSize: '13px',
            color: '#6c757d',
            marginBottom: '20px',
            padding: '8px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px'
          }}>
            <strong>Loan:</strong> {loan.accountName} {loan.loanName || ''}
            <br />
            <strong>Loan ID:</strong> {loan.loanId}
          </div>
        )}

        <p style={{ marginBottom: '20px' }}>
          Are you sure you want to send this disbursement checklist to the Finance team?
        </p>

        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '4px',
          padding: '12px',
          marginBottom: '20px'
        }}>
          <strong>Note:</strong> This action requires:
          <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
            <li>Checklist must be approved</li>
            <li>100% compliance required</li>
            <li>All items must be completed</li>
          </ul>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', gap: '10px' }}>
          <button
            onClick={onCancelClick}
            disabled={submitting}
            style={cancelButtonStyle}
          >
            Close this tab
          </button>
          <button
            onClick={onConfirmClick}
            disabled={submitting}
            style={confirmButtonStyle}
          >
            {submitting ? 'Sending...' : 'Confirm & Send'}
          </button>
        </div>
      </div>
    </div>
  )
}

const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
}

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '450px',
  maxWidth: '600px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
}

const buttonStyle = {
  padding: '12px 24px',
  fontSize: '16px',
  cursor: 'pointer',
  border: 'none',
  borderRadius: '6px',
  fontWeight: '500',
  transition: 'all 0.2s'
}

const confirmButtonStyle = {
  ...buttonStyle,
  backgroundColor: '#28a745',
  color: '#fff'
}

const cancelButtonStyle = {
  ...buttonStyle,
  backgroundColor: '#6c757d',
  color: '#fff'
}

export default SendToFinanceModalUI